import { differenceInCalendarDays, parseISO } from 'date-fns';
import type { TripOverview } from '~/services/engine-ts';

export const getTripNights = (items: TripOverview['items']) => {
  const firstItem = items.find((i) => i.isFirstItem);
  const lastItem = items.find((i) => i.isLastItem);
  if (!firstItem || !lastItem) return 0;
  return differenceInCalendarDays(parseISO(lastItem.endDate), parseISO(firstItem.startDate));
};
